<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="특정 상거래법" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">운영회사 명칭</span>
            <span class="text">주식회사 하치</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">대표 책임자</span>
            <span class="text">하치즈카 켄</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">회사등기 주소·영업소 주소</span>
            <span class="text">〒547-0011</span>
            <span class="text">오사카부 오사카시 히라노구 나가요시 데이치 나나초메 3-39</span>

          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">전화번호</span>
            <span class="text">06-6643-9996</span>
            <span class="text">(※접수 시간: 평일 10시-17시)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">이메일 주소</span>
            <span class="text">support@xeroplace.jp</span>
            <span class="text">※문의는, 사이트내의 채팅으로부터 부탁드리겠습니다.원칙 2 영업일 이내에는 회신하겠습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">가격</span>
            <span class="text">각 상품마다 표시</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
        class="shadow-box-title-description"
        title=""
        >
        <div class="text-container left">
            <span class="text">상품 대금 이외의 필요 요금</span>
            <span class="text">당사가 제공하는 서비스를 이용하기 위한 기기에 관한 비용, 인터넷 접속 요금, 패킷 통신료, 소비세, 대금 지불의 송금 수수료</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">인도시기</span>
            <span class="text">신청 접수시</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">판매 수량</span>
            <span class="text">특히 지정은 없습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">결제 방법</span>
            <span class="text">신용 카드, PayPal, AmazonPay입니다.</span>
            <span class="text">※결제 후의 고객 사정에 의한 캔슬은 받을 수 없습니다.미리 양해 바랍니다.</span>
            <span class="text">마감일까지 지불이 없으면 자동으로 취소됩니다.</span>
            <span class="text">지불시기</span>
            <span class="text">신용카드: 신용카드 회사의 약관에 따라.</span>
            <span class="text">PayPal: PayPal 약관에 근거합니다.</span>
            <span class="text">Amazonpay: Amazonpay 약관에 따라.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">반품특약 및 기한</span>
            <span class="text">원칙 반품 및 교환은 하기 어렵습니다만, 당사에 100%과실이 있는 경우는 대응하겠습니다.</span>
            <span class="text">단, 이하의 경우는 대응하지 않습니다.미리 양해 바랍니다.</span>
            <span class="text">배송 과정에서 분실이나 손상 등이 발생한 경우</span>
            <span class="text">BOX 등 미개봉품의 동영상 촬영 등이 없는 경우</span>
            <span class="text">※재슈링크품의 검품은 특히 유의해 행하고 받고 있습니다.</span>
            <span class="text">상품 도착 후, 10일을 넘었을 경우</span>
            <span class="text">PSA등의 감정품에 상처등이 보여져 버려, 그것을 이유로 한 교환·반품 의뢰를 받은 경우</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">고물상영업허가</span>
            <span class="text">첫째431370066203</span>
            <span class="text">주식회사 제로 플레이스</span>
            <span class="text">사이타마현 경찰위원회</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),

  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px 0;
  margin: 0 auto;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.none{
            color: red;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 100%;
  th, td {
    font-size: 16px;
    color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
    width: 200px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .specific-commerce{
    .scroll-container{
      .shadow-box-title-description{
        .text-container{
          .text{
            font-size: 14px;
          }
        }
      }
    }
  }
  table.code {
    width: 100%;
    th, td {
      display: block;
      font-size: 14px;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
